exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__ErrorMessage__container__Gu-x2 {\n  background-color: #EEE;\n  height: calc(100% - 86px);\n  position: absolute;\n  text-align: center;\n  width: 100%;\n}\n\n.dmb-web__ErrorMessage__message__lGj8l {\n  color: #555;\n  font-size: 16px;\n  height: 60px;\n  left: calc(50% - 118px);\n  line-height: 1.25;\n  position: absolute;\n  text-align: center;\n  top: calc(45% - 30px);\n  width: 236px;\n}\n\n@media only screen\n  and (width <= 750px)  {\n  .dmb-web__ErrorMessage__container__Gu-x2 {\n    height: calc(100% - 56px);\n  }\n}\n", ""]);

// exports
exports.locals = {
	"container": "dmb-web__ErrorMessage__container__Gu-x2",
	"message": "dmb-web__ErrorMessage__message__lGj8l"
};